/* eslint-disable max-len */
import React from 'react';
import { FormFields } from '../Fields';
import { getDataFromSource } from '../utils';

export const generateFields = (input, register, error, defaultValue, setValue, getValues, variant) => {
  if (input?.condition && !showInput(input, getValues)) return null;

  const {
    type,
    variant: inputVariant,
    attributes,
  } = input;

  const FormFieldComponent = FormFields[type];

  return (
    <FormFieldComponent
      input={input}
      control={register}
      error={error}
      defaultValue={defaultValue}
      setValue={setValue}
      getValues={getValues}
      variant={inputVariant || variant || 'standard'}
      attributes={attributes}
    />
  );
};

export const showInput = (input, getValues) => {
  if (!input?.condition || !input?.type) return true;

  const { type, baseOn, baseValue } = input.condition;
  const dataSource = getValues();
  const baseOnValue = getDataFromSource(dataSource, baseOn);

  switch (type) {
    case 'show':
    case 'dynamicShow':
      return (
        baseOnValue !== undefined && baseOnValue !== null && baseOnValue !== ''
      );
    case 'showOnValue':
      return baseOnValue === baseValue;
    case 'showOnValueMultiSelect':
      return baseOnValue?.includes(baseValue);
    case 'showOnValueMulti':
      return baseValue?.includes(baseOnValue) || baseValue?.includes(baseOn);
    case 'hide':
      return !baseValue;
    case 'hideIsEqualToValue':
      return baseOnValue !== baseValue;
    default:
      return true;
  }
};